import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function NewsPage() {
  const news = [
    {
      date: "January 2025",
      category: "Fellowship",
      title: "2025 Fellowship Semi-Finalists Announced For The Stowe Writers' Retreat",
      excerpt: "Stowe Story Labs is pleased to announce the 2025 Stowe Story Labs Accelerator, Bellem Entertainment, and Studio Skyfire Fellowship Semi-Finalists to the 2025 Stowe Writers' Retreat. These fellowships cover the fee to attend Stowe's Writers' Retreat running September 12-16, 2025 in Stowe, VT at the Timberholm Inn plus other benefits. Pamela Stovall was chosen as one of the Bellem Entertainment Fellowship Semi-Finalists for Room of Wonders, television pilot.",
      image: 1,
      link: "https://stowestorylabs.org/news/stowe-story-labs-announces-semifinalists-fellowships-retreat-2025"
    },
    {
      date: "2023",
      category: "Program",
      title: "2023 New Voices • New Mexico Fellows Announced",
      excerpt: "Stowe Story Labs is pleased to announce the 2023 New Voices • New Mexico Program Fellows. Stowe Story Labs is proud to partner with New Mexico Film Office to offer the 2nd Annual, New Voices • New Mexico Program. We are thrilled to announce the selected 10 winners for this three-part writing program.",
      image: "https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/2c8e29f8cdece669ce4f87e2e685d8e4.png",
      link: "https://stowestorylabs.org/news/stowe-story-labs-announces-winners-new-voices-new-mexico-2023"
    },
    {
      date: "2023",
      category: "Incubator",
      title: "Pamela Stovall Chosen to Participate in New Mexico Film Office's Second Successful Year of Screenwriting Incubator 'New Voices • New Mexico'",
      excerpt: "The New Mexico Film Office (NMFO), in partnership with Stowe Story Labs, is proud to announce the overwhelming success of the second annual New Voices • New Mexico screenwriting incubator program. This program, designed to nurture and cultivate the next generation of New Mexico-based film and television writers, has proven to have an immensely positive impact. From a pool of more than 100 applicants, ten writers were selected to participate. Throughout the six-month program, participants took part in intensive workshops, received one-on-one mentorship, and gained access to exclusive networking opportunities.",
      image: "https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/291057794d54a5b82bf34c476f9d9fc2.png",
      link: "https://nmfilm.com/assets/uploads/NMFO-New-Voices-New-Mexico-2023-Recap.pdf"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/4aedf45982ee8d30285abcec855445e2.png"
            alt="News Hero"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        </div>
        
        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl md:text-6xl font-light text-white tracking-tight">News</h1>
          <p className="text-xl text-white/90 mt-4 font-light">Latest updates and announcements</p>
        </div>
      </section>

      {/* Featured News */}
      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-24">
            <div>
              <div className="w-full h-96 bg-gray-200 flex items-center justify-center">
                <img 
                  src="https://public.readdy.ai/ai/img_res/b2f89fd0db4531a4e868a684e009a05d.jpg"
                  alt="Featured News"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            
            <div>
              <span className="inline-block px-3 py-1 bg-black text-white text-xs tracking-wide mb-3">FEATURED</span>
              <p className="text-sm text-gray-500 mb-2">{news[0].date}</p>
              <h2 className="text-3xl font-light text-black mb-4 tracking-tight">{news[0].title}</h2>
              <p className="text-gray-700 text-base leading-relaxed mb-6">{news[0].excerpt}</p>
              <a 
                href={news[0].link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 bg-black text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read More
              </a>
            </div>
          </div>

          {/* All News */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {news.slice(1).map((item, index) => (
              <article key={index} className="bg-white border border-gray-200 hover:shadow-lg transition-shadow">
                <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
                  <img 
                    src={typeof item.image === 'string' ? item.image : `https://readdy.ai/api/search-image?query=Minimalist%20black%20and%20white%20screenwriting%20scene%20with%20elegant%20script%20pages%20and%20fountain%20pen%2C%20clean%20aesthetic%2C%20professional%20photography%2C%20monochromatic%20palette%2C%20sophisticated%20design%2C%20dramatic%20lighting%20creating%20subtle%20shadows%2C%20high%20contrast%20artistic%20style%2C%20film%20industry%20workspace&width=600&height=400&seq=news-item-${item.image}&orientation=landscape`}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs tracking-wide">{item.category}</span>
                    <span className="text-xs text-gray-500">{item.date}</span>
                  </div>
                  <h3 className="text-xl font-medium text-black mb-3 leading-tight">{item.title}</h3>
                  <p className="text-gray-700 text-sm leading-relaxed mb-4">{item.excerpt}</p>
                  <a 
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sm text-black font-medium hover:underline cursor-pointer"
                  >
                    Read More
                    <i className="ri-arrow-right-line ml-2"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-light text-black mb-4 tracking-tight">Stay Informed</h2>
          <p className="text-gray-700 text-base mb-8 leading-relaxed">
            Join my mailing list to receive the latest news, book releases, and exclusive content directly to your inbox.
          </p>
          <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input 
              type="email" 
              placeholder="Your email address"
              className="flex-1 px-4 py-3 border border-gray-300 text-sm focus:outline-none focus:border-black"
            />
            <button 
              type="submit"
              className="px-6 py-3 bg-black text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join List
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
